import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    walletInfo: {},
    selectedWalletInfoPlanDetails:{},
    giftCards:{},
    confirmPurchaseGiftCardDetails:{}
};


const walletInfo = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case Actions.GET_WALLET_INFO_LIST: {
      draft.walletInfo = payload?.walletInfo;
      break;
    }

    case Actions.GET_GIFT_CARD_LIST: {
      draft.giftCards = payload?.giftCards;
      break;
    }

    case Actions.SELECTED_WALLET_PLAN_DETAILS: {
      draft.selectedWalletInfoPlanDetails = payload?.selectedWalletInfoPlanDetails;
      break;
    }

    case Actions.CONFIRM_PURCHASE_GIFT_CARD_DETAILS: {
      draft.confirmPurchaseGiftCardDetails = payload?.confirmPurchaseGiftCardDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default walletInfo;
